
import { Award } from "lucide-react";
import { Leaderboard } from "@/components/leaderboard";
import { useTranslation } from "@/hooks/useTranslation";

export const LeaderboardSection = () => {
  const { t } = useTranslation();
  
  return (
    <section className="mb-8 text-left">
      <div className="flex items-center gap-2 mb-6">
        <Award className="h-5 w-5" />
        <h2 className="text-2xl font-semibold">{t('airport_rankings')}</h2>
      </div>
      <Leaderboard />
    </section>
  );
};
